import request, { ResponseData, PagerData } from '@/libs/request/request'
import { SysConfigQuery } from 'src/api/sys/SysConfigQuery'

// SysConfig
export type SysConfig = {

  // classify
  classify?:string

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // dataType
  dataType?:string

  // 业务Id
  id?:number

  // imageUrl
  imageUrl?:string

  // jsonFile
  jsonFile?:Array<Record<string, any>>

  // keyCode
  keyCode?:string

  // 轮播图场景名称
  name?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // valueStr
  valueStr?:string

  // 标题
  version?:number

  // 第三方视频点播服务id
  videoId?:string
}

export default class SysConfigService {
  /**
   * 添加一个新系统配置
   * @param {SysConfig} sysConfig 实体
   **/
  static addOneSysConfig (sysConfig?:SysConfig):Promise<ResponseData<SysConfig>> {
    return request<ResponseData<SysConfig>>({
      method: 'POST',
      data: sysConfig,
      url: '/admin/SysConfig/SysConfig'
    })
  }

  /**
   * 更新一个配置项
   * @param {SysConfig} sysConfig 实体
   **/
  static updateOneSysConfig (sysConfig?:SysConfig):Promise<ResponseData<SysConfig>> {
    return request<ResponseData<SysConfig>>({
      method: 'PUT',
      data: sysConfig,
      url: '/admin/SysConfig/SysConfig'
    })
  }

  /**
   * 获取的分页数据(支持模糊分页)
   * @param {SysConfigQuery} query 实体查询条件
   **/
  static getPagesOfSysConfig (query?:SysConfigQuery):Promise<ResponseData<PagerData<SysConfig>>> {
    return request<ResponseData<PagerData<SysConfig>>>({
      method: 'POST',
      data: query,
      url: '/admin/SysConfig/SysConfig/pages'
    })
  }

  /**
   * 获取配置的分类
   * @param {number} id id
   **/
  static getSysConfigClassify (id:number):Promise<ResponseData<string>> {
    return request<ResponseData<string>>({
      method: 'GET',
      url: `/admin/SysConfig/SysConfig/getClassify/${id}`
    })
  }

  /**
   * 删除一个
   * @param {number} id id
   **/
  static deleteOneSysConfig (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/SysConfig/SysConfig/${id}`
    })
  }
}
